var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"effect":"dark","placement":"top","content":_vm.content,"open-delay":_vm.openDelay}},[_c('span',[_vm._v(_vm._s(_vm._f("shortString")(_vm.content)))])])}
var staticRenderFns = []

export { render, staticRenderFns }